const mainDomain = (() => {
    if (process.env.ENV === 'prod') return '//www.liontravel.com/';
    return '//uwww.liontravel.com/';
})();

const defaultImg = `${mainDomain}/cto/view/default16-9.jpg`;

export default defaultImg;
export const defaultImg43 = `${mainDomain}/cto/view/default4-3.jpg`;
